import { render, staticRenderFns } from "./pogs-personal-information.vue?vue&type=template&id=52eb7f90&"
import script from "./pogs-personal-information.vue?vue&type=script&lang=js&"
export * from "./pogs-personal-information.vue?vue&type=script&lang=js&"
import style0 from "./pogs-personal-information.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports